import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { h, Component } from 'preact';
import { get, set } from 'diskho';

var FORM_CTX = "@@Form";

var ID_SEPARATOR = ".";

var Field = function (_Component) {
  _inherits(Field, _Component);

  function Field(props) {
    _classCallCheck(this, Field);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onChange = function (_ref) {
      var target = _ref.target;

      _this.setState({
        dirty: true
      });

      _this.context[FORM_CTX].setValue(_this.props.name, target.type === "checkbox" ? target.checked : target.value);
    };

    _this.state = {
      dirty: false
    };
    return _this;
  }

  Field.prototype.componentWillMount = function componentWillMount() {
    if (process.env.NODE_ENV !== "production" && !this.context[FORM_CTX]) {
      console.warn("<Field /> must be a descendant of <Form />");
    }
  };

  Field.prototype.render = function render() {
    var data = {
      name: this.props.name,
      id: this.context[FORM_CTX].getId(this.props.name),
      value: this.context[FORM_CTX].getValue(this.props.name, this.props.def),
      errors: this.context[FORM_CTX].getErrors(this.props.name),
      dirty: this.state.dirty,
      submitted: this.context[FORM_CTX].isSubmitted(),
      onChange: this.props.eventListenerType === "change" ? this.onChange : null,
      onInput: this.props.eventListenerType === "input" ? this.onChange : null
    };

    if (this.props.component) {
      return h(this.props.component, _Object$assign({}, this.props, data));
    } else {
      return this.props.render(data);
    }
  };

  return Field;
}(Component);

Field.defaultProps = {
  eventListenerType: "change"
};


var NestedForm = function (_Component2) {
  _inherits(NestedForm, _Component2);

  function NestedForm() {
    _classCallCheck(this, NestedForm);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  NestedForm.prototype.getChildContext = function getChildContext() {
    var _ref2;

    return _ref2 = {}, _ref2[FORM_CTX] = this, _ref2;
  };

  NestedForm.prototype.getObj = function getObj() {
    return this.context[FORM_CTX].getValue(this.props.name, {});
  };

  NestedForm.prototype.getId = function getId(name) {
    return this.context[FORM_CTX].getId(this.props.name + ID_SEPARATOR + name);
  };

  NestedForm.prototype.setValue = function setValue(name, value) {
    this.context[FORM_CTX].setValue(set(this.getObj(), name, value));
  };

  NestedForm.prototype.getValue = function getValue(name, def) {
    return get(this.getObj(), name, def);
  };

  NestedForm.prototype.getErrors = function getErrors(name) {
    return this.getAllErrors().filter(function (e) {
      return e.field === name;
    });
  };

  NestedForm.prototype.getAllErrors = function getAllErrors() {
    var _this3 = this;

    var l = this.props.name.length + 1;

    return this.context[FORM_CTX].getAllErrors().filter(function (e) {
      return e.field.indexOf(_this3.props.name + ".") === 0;
    }).map(function (_ref3) {
      var field = _ref3.field,
          error = _ref3.error;
      return { field: field.substring(l), error: error };
    });
  };

  NestedForm.prototype.isSubmitted = function isSubmitted() {
    return this.context[FORM_CTX].isSubmitted();
  };

  NestedForm.prototype.componentWillMount = function componentWillMount() {
    if (process.env.NODE_ENV !== "production" && !this.context[FORM_CTX]) {
      console.warn("<NestedForm /> must be a descendant of <Form />");
    }
  };

  NestedForm.prototype.render = function render() {
    return h("div", null, this.props.children);
  };

  return NestedForm;
}(Component);

var Form = function (_Component3) {
  _inherits(Form, _Component3);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this4 = _possibleConstructorReturn(this, _Component3.call(this, props));

    _this4.onSubmit = function (e) {
      var validations = _this4.props.validations;


      if (validations && validations.length) {
        _this4.setState({ dirty: true });

        e.preventDefault();
        e.stopPropagation();

        if (_this4.props.onError) {
          _this4.props.onError(e, validations);
        }

        return false;
      }

      _this4.setState({ dirty: false });

      _this4.props.onSubmit(e, _this4.props.state);
    };

    _this4.state = { dirty: false };
    return _this4;
  }

  Form.prototype.getChildContext = function getChildContext() {
    var _ref4;

    return _ref4 = {}, _ref4[FORM_CTX] = this, _ref4;
  };

  Form.prototype.getId = function getId(name) {
    return this.props.name ? this.props.name + ID_SEPARATOR + name : name;
  };

  Form.prototype.setValue = function setValue(name, value) {
    var newState = set(this.props.state, name, value);

    if (newState !== this.props.state) {
      this.props.onChange(newState);
    }
  };

  Form.prototype.getValue = function getValue(name, def) {
    return get(this.props.state, name, def);
  };

  Form.prototype.getErrors = function getErrors(name) {
    return this.props.validations.filter(function (e) {
      return e.field === name;
    });
  };

  Form.prototype.getAllErrors = function getAllErrors() {
    return this.props.validations;
  };

  Form.prototype.isSubmitted = function isSubmitted() {
    return this.state.dirty;
  };

  Form.prototype.render = function render() {
    var _props = this.props,
        validations = _props.validations,
        onChange = _props.onChange,
        onError = _props.onError,
        onSubmit = _props.onSubmit,
        state = _props.state,
        children = _props.children,
        rest = _objectWithoutProperties(_props, ["validations", "onChange", "onError", "onSubmit", "state", "children"]);

    return h("form", _Object$assign(rest, {
      novalidate: true,
      onSubmit: this.onSubmit
    }), children);
  };

  return Form;
}(Component);
Form.defaultProps = {
  validations: []
};

var rules = function rules(vs) {
  return function (s) {
    return [].concat.apply([], vs.map(function (i) {
      return i(s);
    }));
  };
};

var nestedRule = function nestedRule(k, v) {
  return function (s) {
    return typeof s === "object" && s ? v(s[k]).map(function (_ref) {
      var error = _ref.error,
          field = _ref.field;
      return { error: error, field: k + "." + field };
    }) : [];
  };
};

var conditional = function conditional(c, v) {
  return function (s) {
    return c(s) ? v(s) : [];
  };
};

var ADDRESS = /^[\D][\D\d]*$/;
var TEXT = /^[^\d]+$/;
var POSTAL_CODE = /^\d{3}\s?\d{2}$/;
var EMAIL = /\S+@\S+\.\S+/;
var PHONE = /^(?=.*[0-9]{2,})[-\s+()0-9]+$/;

var numeric = function numeric(x) {
  return !isNaN(parseFloat(x)) && isFinite(x);
};

var required = function required(f) {
  return function (s) {
    return typeof s === "object" && s[f] ? [] : [{ error: "REQUIRED", field: f }];
  };
};

var lengthGt = function lengthGt(f, l) {
  return function (s) {
    return s[f] && s[f].length > l ? [] : [{ error: "LENGTH_GT", field: f, lengthGt: l }];
  };
};

var lengthLt = function lengthLt(f, l) {
  return function (s) {
    return s[f] && s[f].length < l ? [] : [{ error: "LENGTH_LT", field: f, lengthLt: l }];
  };
};

var truthy = function truthy(f) {
  return function (s) {
    return s[f] ? [] : [{ error: "TRUTHY", field: f }];
  };
};

var match = function match(f1, f2) {
  return function (s) {
    return s[f1] === s[f2] ? [] : [{ error: "MATCH", field: f2, match: f2 }];
  };
};

var isAddress = function isAddress(f) {
  return function (s) {
    return typeof s === "object" && s[f] && ADDRESS.test(s[f]) ? [] : [{ error: "ADDRESS", field: f }];
  };
};

var isPhone = function isPhone(f) {
  return function (s) {
    return PHONE.test(s[f]) ? [] : [{ error: "PHONE", field: f }];
  };
};

var isPostalCode = function isPostalCode(f) {
  return function (s) {
    var value = parseInt(s[f].replace(/\s/g, ""), 10);
    return POSTAL_CODE.test(s[f]) && value !== NaN && value > 10000 ? [] : [{ error: "POSTCODE", field: f }];
  };
};

var isText = function isText(f) {
  return function (s) {
    return TEXT.test(s[f]) ? [] : [{ error: "TEXT", field: f }];
  };
};

var isEmail = function isEmail(f) {
  return function (s) {
    return EMAIL.test(s[f]) ? [] : [{ error: "EMAIL", field: f }];
  };
};

var isNumeric = function isNumeric(f) {
  return function (s) {
    return numeric(s[f]) ? [] : [{ error: "NUMERIC", field: f }];
  };
};

export { FORM_CTX, Field, NestedForm, Form, rules, nestedRule, conditional, ADDRESS, TEXT, POSTAL_CODE, EMAIL, PHONE, numeric, required, lengthGt, lengthLt, truthy, match, isAddress, isPhone, isPostalCode, isText, isEmail, isNumeric };
//# sourceMappingURL=index.es2015.js.map
